<template>
  <div id="app">
    <NotFound v-if="isNotFound" />
    <router-view v-else />
    <notifications width="384" animationName="anim-notification" :duration="4000" :position="'bottom right'">
      <template #body="{ item, close }">
        <Notification :title="item.title" :text="item.text" :type="item.type" :group="item.group" :data="item.data" :length="item.length" @close="close" />
      </template>
    </notifications>
  </div>
</template>

<script>
import { defineAsyncComponent, provide } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { mapGetters } from "vuex";
import Notification from "~/components/notifications/Notification";
import { SESSION_TOKEN } from "~/constants/settings";
import { store } from "~/store";
import { isNotFound } from "~/utils/notFound";
import { apolloClient } from "~/vue-apollo";

export default {
  components: {
    Notification,
    NotFound: defineAsyncComponent(() => import("~/views/NotFound")),
  },

  setup() {
    provide(DefaultApolloClient, apolloClient);

    return { isNotFound };
  },

  computed: {
    ...mapGetters("session", ["status", "tokenData"]),
    fguInstitutionNumber() {
      return this.$route.params.fguInstitutionNumber;
    },
  },

  watch: {
    status() {
      const userId = this.tokenData?.user?.id;

      this.$sentry.setUser({ id: userId });
    },

    fguInstitutionNumber: {
      immediate: true,
      handler(fguInstitutionNumber) {
        this.$sentry.setTag("fguInstitutionNumber", parseInt(fguInstitutionNumber) || undefined);
      },
    },
  },

  created() {
    window.addEventListener("storage", this.signOutAllTabs);
  },

  methods: {
    signOutAllTabs() {
      if (!localStorage.getItem(SESSION_TOKEN)) {
        store.dispatch("session/refreshSession");
      }
    },
  },
};
</script>
